module.exports = __webpack_public_path__ + "img/sun.9df716ac.svg";